"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function useOverflow(ref, targetHeight, onOverflow) {
  react_1.useEffect(function () {
    if (ref.current !== null) {
      var _ref$current$getBound = ref.current.getBoundingClientRect(),
          height = _ref$current$getBound.height;

      if (height >= targetHeight) {
        onOverflow();
      }
    }
  }, []);
}

exports.default = useOverflow;